import React, { useState } from "react";
import { createDefect } from "../../services/api";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/BreadCrumbs";

const DefectCreate = () => {
  const navigate = useNavigate();
  const [testData, setTestData] = useState({
    nombre: "",
    descripcion: "",
    assignedTo: "",
    estado: "",
    proyectos_id: "",
  });

  const handleChange = (e) => {
    setTestData({
      ...testData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createDefect(testData);
      navigate("/defects");
    } catch (error) {
      console.error("Error al crear el defecto", error);
    }
  };

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
    { name: "Test", url: "/dashboard/projects/1/test" },
  ];

  return (
    <>
      <h2>Crear Defecto</h2>
      <Breadcrumbs paths={breadcrumbPaths} />
      <form onSubmit={handleSubmit}>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">
            Nombre del Caso de Prueba
          </label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="nombre"
              value={testData.nombre}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Descripción</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              value={testData.descripcion}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Asignado a</label>
          <div class="col-sm-10">
            <input
              type="text"
              className="form-control"
              name="assignedTo"
              value={testData.asignado_a}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Estado</label>
          <div class="col-sm-10">
            <select
              className="form-select"
              name="estado"
              value={testData.estado}
              onChange={handleChange}
              required
            >
              <option value="">Seleccionar...</option>
              <option value="Abierto">Abierto</option>
              <option value="En progreso">En progreso</option>
              <option value="Resuelto">Resuelto</option>
            </select>
          </div>
        </div>
        <div style={{ textAlign: "end" }}>
          <button type="submit" className="btn btn-primary">
            Crear
          </button>
        </div>
      </form>
    </>
  );
};

export default DefectCreate;
